module.exports = __webpack_public_path__ + "static/media/phone.93583e8c.svg";